import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function MuiBackdrop(theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[800], 0.4),
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
